import { render, staticRenderFns } from "./hold.vue?vue&type=template&id=69152756&scoped=true&"
import script from "./hold.vue?vue&type=script&lang=js&"
export * from "./hold.vue?vue&type=script&lang=js&"
import style0 from "./hold.vue?vue&type=style&index=0&id=69152756&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69152756",
  null
  
)

export default component.exports